export function init_taboola_home(){

    window._taboola = window._taboola || [];
    _taboola.push({homepage:'auto'});
    add_taboola_loader();
    
}


export function init_taboola_articles(){

    window._taboola = window._taboola || [];
    _taboola.push({article:'auto'});
    add_taboola_loader();
}


function add_taboola_loader(){

    !function (e, f, u, i) {
        if (!document.getElementById(i)){
            e.async = 1;
            e.src = u;
            e.id = i;
            f.parentNode.insertBefore(e, f);
        }
    }
    (document.createElement('script'),
        document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/theaffinitymediaexchangetame-rcp/loader.js',
        'tb_loader_script');
    if(window.performance && typeof window.performance.mark == 'function')
    {window.performance.mark('tbl_ic');
    }
}